import React, {useEffect, useState} from 'react'
import Banner1Login from '../assets/img/Banner1Login.png'
import Banner2Login from '../assets/img/Banner2Login.png'
import blackGreenFull from '../assets/img/Full_Negro+Verde.svg'
import '../assets/css/LoginNew.css'
import {useNavigate, useSearchParams} from 'react-router-dom'
import { Mail, ChevronRight } from 'lucide-react'
export const EmailCheck = () => {
	const [activeScreen, setActiveScreen] = useState(false)
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()
	const email = searchParams.get('email')
	useEffect(() => {
		setTimeout(() => {
			setActiveScreen(true)
		}, 200)
	}, [])
	return (
		<div
			className={`LoginNew ForgetPasswordNew  EmailCheck ${
				activeScreen && 'EmailCheckActive'
			}`}
		>
			<img src={Banner1Login} alt='' className='Banner1Login' />
			<img src={Banner2Login} alt='' className='Banner2Login' />
			<img src={blackGreenFull} alt='' className='Full_NegroVerde' />

			<form action='#'>
				<div className='top_box'>
					<div style={{width: 52, height: 52, borderRadius: 26, background: '#F0F4FC', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
						<Mail size={28} color='#3676F5' />
					</div>
				</div>
				<div className='body_area'>
					<p>Revisa tu Email</p>
					<p>
						Recibirás un link para poder reestablecer <br /> tu contraseña
					</p>
					{email && <span>{email}</span>}
					<span>Recuerda revisar tu carpeta de Spam</span>

					<div className='button_wrapper'>
						<button
							onClick={(e) => {
								e.preventDefault()
								navigate('/LoginNew')
							}}
						>
							Volver al Login
							<ChevronRight size={16} color='white' />
						</button>
					</div>
				</div>
			</form>
		</div>
	)
}
